import { h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';

export const MyAccountToggleSaveButtonLoginButton = ({ onClick }: { onClick: () => void }) => (
  <button onClick={onClick}>{i18nTranslate('login-to-continue')}</button>
);
